module.exports = "<p data-bind=\"safeHtml: text\"></p>\r\n"
window.define('text!flow/viewModels/InformationDialog.html', [], function() { return __webpack_module__.exports; });